/** Persistencia cliente: tours de OnboardingGuide ya vistos o completados. */

export const ONBOARDING_GUIDE_SEEN_STORAGE_KEY = 'onboarding_guide_seen_tours';

function readSeenSet(): Set<string> {
  try {
    const raw = localStorage.getItem(ONBOARDING_GUIDE_SEEN_STORAGE_KEY);
    if (!raw) return new Set();
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return new Set();
    return new Set(parsed.filter((id): id is string => typeof id === 'string'));
  } catch {
    return new Set();
  }
}

function writeSeenSet(ids: Set<string>): void {
  try {
    localStorage.setItem(ONBOARDING_GUIDE_SEEN_STORAGE_KEY, JSON.stringify([...ids]));
  } catch {
    /* ignore quota / private mode */
  }
}

export function isOnboardingTourSeen(tourId: string): boolean {
  return readSeenSet().has(tourId);
}

export function markOnboardingTourSeen(tourId: string): void {
  const next = readSeenSet();
  next.add(tourId);
  writeSeenSet(next);
}

export function clearOnboardingTourSeen(tourId: string): void {
  const next = readSeenSet();
  next.delete(tourId);
  writeSeenSet(next);
}

export function clearAllOnboardingToursSeen(): void {
  try {
    localStorage.removeItem(ONBOARDING_GUIDE_SEEN_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
